const initialState = {

  states: {},
}

const members = (state = initialState, action) => {
  switch (action.type) {

    case 'SET_MEMBERS_LIST':
      return {
        ...state,
        membersList: action.membersData.profileData,
        showMember : true,
        showEditMembers : false,
        success: action.membersData.success,
      }

      case 'EDIT_MEMBERS':
        return {
          ...state,
          editMemberData : action.membersData,
          showMember : false,
          showEditMembers : true,
        }

      case 'SET_USER_TRANSACTION_DATA':
      return {
        ...state,
        showMember : false,
        showEditMembers : false,
        showUserTranaction : true,
        UserTranactionSuccess : action.transactionData.success,
        UserTranactionData: action.transactionData.transactionData
      }

    default:
      return state;
  }
};
export default members;



// WEBPACK FOOTER //
// ./src/reducers/members.js